/* eslint react/prop-types: 0 */
import React from "react";
import { Link } from "gatsby";

import * as theme3Styles from "../scss/theme3.module.scss";
import { getTranslatedValue } from "../../../helpers/translationHelper";
import {
  calculateBedroomsRange,
  calculateBathroomsRange,
} from "../../../helpers/buildingHelper";
import { prepareImageURL } from "../../../helpers/helper";

import property1 from "../images/property-image-1.jpg";

const BuildingList = ({ buildings, locale, defaultLocale }) => {
  return (
    <div className={`${theme3Styles.productRow}`}>
      {buildings.map((building) => {
        const {
          pictures,
          property_type,
          measurement_unit,
          layouts,
          translations,
        } = building;

        const picture =
          pictures.length > 0
            ? prepareImageURL(pictures[0], 480, 320, false)
            : property1;

        const bedroomsRange = calculateBedroomsRange(layouts);
        const bathroomsRange = calculateBathroomsRange(layouts);

        return (
          <div className={theme3Styles.colm} key={building.uuid}>
            <div className={`${theme3Styles.productBox}`}>
              <Link
                to={`/${locale}/building/${building.uuid}`}
                className={theme3Styles.image}
              >
                <img alt="image" src={picture} />
                {(() => {
                  if (property_type && property_type.translations.length > 0) {
                    return (
                      <span className={theme3Styles.type}>
                        {getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </span>
                    );
                  }
                })()}
                <span className={theme3Styles.uuid}>{building.name}</span>
              </Link>
              <div className={theme3Styles.details}>
                <div className={`${theme3Styles.priceC}`}>
                  <ul className={theme3Styles.features}>
                    {bedroomsRange != 0 && <li>
                      {bedroomsRange}
                      <abbr> bds</abbr>
                    </li>}
                    {bathroomsRange != 0 && <li>
                      {bathroomsRange}
                      <abbr> ba</abbr>
                    </li>}
                    {building.built_in_area_value && <li>
                      {building.built_in_area_value}
                      <abbr>
                        {" "}
                        {measurement_unit ? measurement_unit.name : ""}
                      </abbr>
                    </li>}
                  </ul>
                </div>
                <h4
                  dangerouslySetInnerHTML={{
                    __html:
                      getTranslatedValue(
                        translations,
                        "headline",
                        locale,
                        defaultLocale
                      ) || "",
                  }}
                ></h4>
                <h5>{building.location}</h5>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BuildingList;
